import styled from 'styled-components';

import { SWReactIcons } from '@similarweb/icons';

export const StyledTooltipTitle = styled.p`
  font-weight: 700;
  margin: 0;
`;

export const StyledTooltipText = styled.p`
  margin: 0;
`;

export const StyledDisabledIcon = styled(SWReactIcons)`
  width: 20px;
  height: 20px;
`;
